import { render, staticRenderFns } from "./EquipeForm.vue?vue&type=template&id=cc30c002&scoped=true&lang=pug&"
import script from "./EquipeForm.vue?vue&type=script&lang=js&"
export * from "./EquipeForm.vue?vue&type=script&lang=js&"
import style0 from "./EquipeForm.vue?vue&type=style&index=0&id=cc30c002&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc30c002",
  null
  
)

export default component.exports